import { createFileRoute, Outlet } from '@tanstack/react-router';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from '@/app/ui/components/breadcrumb';
import {
  Header,
  HeaderBackButton,
  HeaderSidebarTrigger,
  HeaderUserMenu,
} from '@/app/ui/components/header';
import { H1 } from '@/app/ui/components/heading';
import { MainContainer, MainHeader, MainScrollArea } from '@/app/ui/components/main';
import { Sidenav, SidenavItem, SidenavLink, SidenavList } from '@/app/ui/components/sidenav';
import { SettingsIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { useTranslations } from 'use-intl';

export const Route = createFileRoute('/_authed/(organization)/_layout/settings/_layout')({
  component: RouteComponent,
});

function RouteComponent() {
  const t = useTranslations('pages.organizationSettings');

  return (
    <>
      <Header>
        <HeaderBackButton />
        <HeaderSidebarTrigger />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbPage>
                <HugeiconsIcon icon={SettingsIcon} />
                {t('breadcrumbs.settings')}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <HeaderUserMenu />
      </Header>
      <MainScrollArea>
        <MainHeader>
          <H1>{t('breadcrumbs.settings')}</H1>
        </MainHeader>
        <div className="flex max-lg:flex-col">
          <Sidenav>
            <SidenavList className="px-x">
              <SidenavItem>
                <SidenavLink activeOptions={{ exact: true }} to={'/settings'}>
                  {t('sidenavItems.profile')}
                </SidenavLink>
              </SidenavItem>
              <SidenavItem>
                <SidenavLink to={'/settings/clients'}>{t('sidenavItems.clients')}</SidenavLink>
              </SidenavItem>
              <SidenavItem>
                <SidenavLink to={'/settings/integrations'}>
                  {t('sidenavItems.integrations')}
                </SidenavLink>
              </SidenavItem>
            </SidenavList>
          </Sidenav>
          <MainContainer className="max-w-xl">
            <Outlet />
          </MainContainer>
        </div>
      </MainScrollArea>
    </>
  );
}
